import helloJoypixel from './lottie/joypixel/1F44B.json';
import partyJoypixel from './lottie/joypixel/party.json';
import thumbsUpJoypixel from './lottie/joypixel/1F44D.json';
import clapJoypixel from './lottie/joypixel/1F44F.json';
import fireJoypixel from './lottie/joypixel/1F525.json';
import laughJoypixel from './lottie/joypixel/1F923.json';
import thinkingJoypixel from './lottie/joypixel/1F914.json';
import angryJoypixel from './lottie/joypixel/1F621.json';
import thumbsDownJoypixel from './lottie/joypixel/1F44E.json';
import tearsJoypixel from './lottie/joypixel/1F62D.json';
import poopJoypixel from './lottie/joypixel/1F4A9.json';
import helloApple from './lottie/apple/1F44B.json';
import heartApple from './lottie/apple/2764_FE0F.json';
import thumbsUpApple from './lottie/apple/1F44D.json';
import clapApple from './lottie/apple/1F44F.json';
import partyApple from './lottie/apple/party.json';
import fireApple from './lottie/apple/1F525.json';
import laughApple from './lottie/apple/1F923.json';
import thinkingApple from './lottie/apple/1F914.json';
import angryApple from './lottie/apple/1F620.json';
import thumbsDownApple from './lottie/apple/1F44E.json';
import tearsApple from './lottie/apple/1F62D.json';
import poopApple from './lottie/apple/1F4A9.json';
import { getAnimationPlatform } from './platformDetection';

const LOTTIE_FILES_MAP_APPLE: Record<string, any> = {
    '1F44B.lottie': helloApple,
    '2764_FE0F.lottie': heartApple,
    '1F44D.lottie': thumbsUpApple,
    '1F44F.lottie': clapApple,
    'party.lottie': partyApple,
    '1F525.lottie': fireApple,
    '1F923.json': laughApple,
    '1F914.lottie': thinkingApple,
    '1F620.lottie': angryApple,
    '1F44E.lottie': thumbsDownApple,
    '1F62D.lottie': tearsApple,
    '1F4A9.lottie': poopApple,
};

const LOTTIE_FILES_MAP_JOYPIXEL: Record<string, any> = {
    '1F44B.lottie': helloJoypixel,
    '2764_FE0F.lottie': heartApple,
    '1F44D.lottie': thumbsUpJoypixel,
    '1F44F.lottie': clapJoypixel,
    'party.lottie': partyJoypixel,
    '1F525.lottie': fireJoypixel,
    '1F923.json': laughJoypixel,
    '1F914.lottie': thinkingJoypixel,
    '1F620.lottie': angryJoypixel,
    '1F44E.lottie': thumbsDownJoypixel,
    '1F62D.lottie': tearsJoypixel,
    '1F4A9.lottie': poopJoypixel,
};

const getLottieFilesMap = (): Record<string, any> => {
    const platform = getAnimationPlatform();
    return platform === 'apple' ? LOTTIE_FILES_MAP_APPLE : LOTTIE_FILES_MAP_JOYPIXEL;
};

export const getLottieFile = async (animationFile: string) => {
    const filesMap = getLottieFilesMap();
    const file = filesMap[animationFile];

    if (!file) {
        console.error(`[Lottie Cache] Animation file not found: ${animationFile}`);
        throw new Error(`Animation file not found: ${animationFile}`);
    }

    return file;
};
